import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UtilsService} from '../../core/utils/utils.service';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/observable/forkJoin';
import {PowerBiService} from '../../core/services/power-bi.service';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-iframe-page-diferentes',
  templateUrl: './iframe-page-diferentes.component.html',
  styleUrls: ['./iframe-page-diferentes.component.scss']
})

export class IframePageDiferentesComponent implements OnInit {
  data;
  activeTab: {};
  activeTabIndex = 0;
  tabs = [];
  usuario;
  loaded = false;

  constructor(private _utils: UtilsService, private _powerBi: PowerBiService,
              private _activatedRoute: ActivatedRoute, private _sanitizer: DomSanitizer) {
    this.usuario = this._utils.getUsuario();
  }

  async getParamsDesktop(config) {
    const observables = [];
    for (const tab of config['tabs']) {
      const tabObj = Object.assign({}, tab);
      const params = {
        lojaId: this.usuario ? this.usuario.loja : 0,
        tipo: tab['linkNome']
      };
      observables.push(this._powerBi.getPowerBi(params));
      this.tabs.push(tabObj);
    }
    Observable.forkJoin(observables)
      .subscribe(dataArray => {
        for (let dataIndex = 0; dataIndex < dataArray.length; dataIndex++) {
          if (dataArray[dataIndex] && dataArray[dataIndex]['link']) {
            this.tabs[dataIndex]['link'] = this._sanitizer.bypassSecurityTrustResourceUrl(dataArray[dataIndex]['link']);
          }
        }
        this.loaded = true;
      });
  }

  changeIframeTab(tab, i) {
    this.activeTab = tab;
    this.activeTabIndex = i;
  }

  openFullScreen(iframe) {
    if (iframe.requestFullscreen) {
      iframe.requestFullscreen();
    } else if (iframe.mozRequestFullScreen) {
      iframe.mozRequestFullScreen();
    } else if (iframe.webkitRequestFullscreen) {
      iframe.webkitRequestFullscreen();
    } else if (iframe.msRequestFullscreen) {
      iframe.msRequestFullscreen();
    }
  }


  ngOnInit() {
    if (this.data) {
      this.getParamsDesktop(this.data);
    }
  }
}
